import { t } from "i18next";
import logo from "assets/images/logo.svg";
import bgMaintenance from "assets/images/heroSection/bgMaintenance.svg";
import Footer from "components/Footer";
import { useAfricanSocialProtection } from "context/africanSocialProtection";
/** @jsxImportSource @emotion/react */
import tw from "twin.macro";

const MaintenancePage = () => {
    const { language } = useAfricanSocialProtection();

    return (
        <div
            tw="min-h-screen flex flex-col bg-no-repeat bg-cover"
            style={{ backgroundImage: `url(${bgMaintenance})` }}
        >
            <div tw="p-[2rem]">
                <div
                    tw="flex items-center gap-[1rem] w-[14rem] leading-[0.8rem]"
                    css={[language !== "eng" && tw`w-[15rem]`]}
                >
                    <img src={logo} alt="Logo" />
                    <h1 tw="text-[0.75rem]">
                        <span tw="uppercase text-blue-600 font-bold">
                            {t("title")}
                        </span>
                        <p tw="text-purple-400">{t("sub_title")}</p>
                    </h1>
                </div>
            </div>
            <div tw="flex-1 flex items-center justify-center">
                <div tw="text-center px-[2rem]">
                    <h2 tw="text-blue-600 text-[42px] font-semiBold leading-[28px]">
                        We are under maintenance.
                    </h2>
                    <p tw="mt-[2rem] text-purple-800 text-[18px] font-light leading-[27px]">
                        Our website is currently under maintenance and will go back shortly.
                        <br />
                        Thank you for your patience.
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MaintenancePage;
